module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"popup-card popup-card-sm text-left\"> <a href=\"#\" class=\"one-time-charge ml-2 show-popup\"><span class=\"fa fa-plus-circle\"></span> Add Funds</a> <div class=\"card\"> <div class=\"card-body\"> <div class=\"form-group\"> <div id=\"payment_method_selector\"></div> </div> <div class=\"form-group\"> <div id=\"charge_amount_selector\"></div> </div> <div class=\"alert alert-info small\">One-time charges are <a href=\"/is-there-a-one-time-charge-required-to-use-easypost\">not required to use EasyPost</a>.</div> <button class=\"btn btn-secondary btn-block submit_charge\">Add</button> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/account_balance/one_time_charge_popup.ejs
// module id = 1260
// module chunks = 1